export const removeLocalStorageAdmin = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("x-access-employeeId");
    localStorage.removeItem("x-access-roleId");
    localStorage.removeItem("x-access-token-expiration");
    localStorage.removeItem("admin-remember");
    localStorage.removeItem('seller-remember')
  };